import { configurePodcast } from './configure-podcast.service';
import { createPodcast } from './create-podcast.service';
import { deletePodcast } from './delete-podcast.service';
import { getPodcastConfiguration } from './get-podcast-configuration.service';
import { getPodcastDetails } from './get-podcast-details.service';
import { getPodcasts } from './get-podcasts.service';
import { updatePodcast } from './update-podcast.service';

export const podcastsService = {
  getPodcasts,
  createPodcast,
  deletePodcast,
  updatePodcast,
  configurePodcast,
  getPodcastDetails,
  getPodcastConfiguration,
};
